import React from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {observer} from "mobx-react";
import styles from "../styles/previous-meetings-widget.module.scss";
import classNames from "classnames";

export class PreviousMeetingsWidgetScoreResultProps extends BaseProps {
  score: String;
  type: String;
}

export const PreviousMeetingsWidgetScoreResult = observer(({score, type}: PreviousMeetingsWidgetScoreResultProps) => {
  return (
    <div className={classNames(styles.score_results_container)}>
      <div className={classNames(styles.score)}>{score}</div>
      <div className={classNames(styles.type)}>{type}</div>
    </div>
  );
});
